var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template012_cover"},[_c('img',{attrs:{"src":_vm.rt+'/img/lp/icon.png',"alt":"アドタスカルアイコン画像"}}),_c('p',{staticClass:"template012_title"},[_vm._v(_vm._s(_vm.TemplateTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }